// extracted by mini-css-extract-plugin
export default {"aboutme":"AboutMe_aboutme__Xk2x3","sl":"AboutMe_sl__hI+Ph","skills":"AboutMe_skills__+rjik","languages":"AboutMe_languages__VrTgH","false":"AboutMe_false__yiujJ"};